<template>
    <div v-if="isLoggedIn" style="width: 50rem; min-width: 40rem; max-width: 93vw; height: 80%;">
        <div style="height: 0.5rem; margin-top: 0.7rem; margin-bottom: 1.7rem;">
            <router-link unstyled :to="{ name: 'Licenses'}">
                <Button text icon="pi pi-angle-left" label="Back to Licenses" size="small" class="p-0 m-0"/>
            </router-link>
        </div>
        <div class="flex flex-row justify-content-between align-items-center">
            <span style="color: var(--theme-font-color); font-size: var(--profile-maintitle-font-size); font-weight: var(--profile-maintitle-font-weight);">Profile Settings</span>
            <Button rounded text @click="loadProfileInfo" style="border-radius: 980px; padding: 0.5rem;" :disabled="httpGetProfileLoading">
                <SvgRefresh className="table-licenses-svg" color="var(--button-normal-color)"/>
            </Button>
        </div>
        <MyProfileContent v-if="!httpGetProfileLoading" @refresh-profile-info="loadProfileInfo"/>
        <div v-else style="width: 100%; height: 100%;" class="flex justify-content-center align-items-center">
            <LoadingSpinner/>
        </div>
    </div>
</template>

<script setup>
import { ref, watchEffect, computed } from 'vue'
// PrimeVue
import Button from 'primevue/button'
// vue
import MyProfileContent from '@/components/MyProfile/MyProfileContent.vue'
import LoadingSpinner from '@/components/Modules/LoadingSpinner.vue';
import SvgRefresh from '@/components/SVGs/SvgRefresh.vue';
// Others
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

const router = useRouter()
const store = useStore()

// Toast
import toastService from '@/composables/toastService';

import useApiRequest from '@/composables/HTTPS/useApiRequest';
const { fetchGetProfile } = useApiRequest()
const httpGetProfileLoading = ref(false)
const httpGetProfileData = ref(null)

// --- REDIRECT IF NOT CONNECTED ---
const isLoggedIn = computed(() => store.getters['user/isLoggedIn'])
watchEffect(() => {
    if (!isLoggedIn.value) { router.push({ path: '/login' }) }
})

// --- Load profile info ---
const loadProfileInfo = async () => {
    // Send HTTP request without any passwordVerification
    httpGetProfileLoading.value = true
    try {
        httpGetProfileData.value = await fetchGetProfile()
        // Refresh of data
        store.commit('user/setUser', httpGetProfileData.value.account_info)
        // Success toast
        // toastService.add({ severity: 'success', summary: "Load Profile Informations: Success", detail: 'Your profile informations have been successfully loaded.', life: 5000 });
    } catch (err) {
        handleGetProfileError(err)
    } finally {
        httpGetProfileLoading.value = false
    }
}
// Handle an error from the server
const handleGetProfileError = (error) => {
    try {
        if (error.response == null) { // If there is no .response key, then it means it is not an error from the server, it did not reach it
            toastService.add({ severity: 'error', summary: `Get Profile: Server not reachable.`, detail: `The server is not reachable. Please make sure you are connected to the internet. If you are, please try again.`, life: 5000 });
            return;
        }
        const errorStatus = error.response.status
        const errorCode = error.response.data.error_code
        const errorMessage = error.response.data.error_message
        switch (errorStatus) {
            case 400: // ACCESS_TOKEN_MISSING (400)
                if (errorCode == 'ACCESS_TOKEN_MISSING') {
                    toastService.add({ severity: 'error', summary: "Get Profile: Authorization Issue.", detail: 'You are not logged in.', life: 5000 });
                    // Logout
                    logoutUser()
                }
                else {  toastService.add({ severity: 'error', summary: `Get Profile: Error ${errorStatus}.`, detail: errorMessage, life: 5000 }); }
                break;
            case 401: // ACCESS_TOKEN_EXPIRED / ACCESS_TOKEN_INVALID (401)
                if (errorCode == 'ACCESS_TOKEN_EXPIRED' || errorCode == 'ACCESS_TOKEN_INVALID') {
                    // Logout: Do nothing, the interceptor should have made a refresh token request!
                    // logoutUser()
                }
                else {  toastService.add({ severity: 'error', summary: `Get Profile: Error ${errorStatus}.`, detail: errorMessage, life: 5000 }); }
                break;
            case 404: // Account not found: account has disappear : ACCOUNT_NOT_FOUND (404) => toast + logout
                if (errorCode == 'ACCOUNT_NOT_FOUND') {
                    toastService.add({ severity: 'error', summary: "Get Profile: Account Not Found.", detail: 'The account no more exists.', life: 5000 });
                    // Logout
                    logoutUser()
                }
                else {  toastService.add({ severity: 'error', summary: `Get Profile: Error ${errorStatus}.`, detail: errorMessage, life: 5000 }); }
                break;
            default:
                toastService.add({ severity: 'error', summary: `Get Profile: Error ${errorStatus}.`, detail: errorMessage, life: 5000 });
                break;
        }
    } catch {
        toastService.add({ severity: 'error', summary: `Get Profile: Server not reachable.`, detail: `The server is not reachable. Please make sure you are connected to the internet. If you are, please try again.`, life: 5000 });
    }
}
</script>

<style scoped>
</style>